export default "__VITE_ASSET__B63_KnvH__"